export class ObjectUtils {
    static getObjectCopy(obj){
        let strObj=JSON.stringify(obj);
        return JSON.parse(strObj);
    }
}
